module.exports = __webpack_public_path__ + "static/001 Buero AA-c9f847a29b472c8d171a392f8020868c.svg";